import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import api from '../Services/api';

interface PaginationLink {
  url: string | null;
  label: string;
  active: boolean;
}

interface MetaData {
  current_page: number;
  from: number;
  last_page: number;
  links: PaginationLink[];
  path: string;
  per_page: number;
  to: number;
  total: number;
}

interface PaginatedResponse<T> {
  data: T[];
  meta: MetaData;
}

interface Options {
  enabled?: boolean;
  page?: number;
  paginate?: boolean;
  queryParams?: Record<string, any>;
  // Padrão: atualização automática do queryClient. false em telas que copiam
  // os dados para um estado editável (a atualização apagaria a edição).
  refetchInterval?: number | false;
}

export const useQueryFetchPages = <T>(
  key: string[],
  url: string,
  options: Options = {}
) => {
  const {
    enabled = true,
    page = 1,
    paginate = true,
    queryParams = {},
    refetchInterval,
  } = options;

  const fullParams = {
    page: paginate ? page : undefined,
    paginate: paginate ? true : false,
    ...queryParams,
  };

  return useQuery<PaginatedResponse<T>, Error>({
    queryKey: [...key, { page, ...queryParams }],
    queryFn: async () => {
      const { data } = await api.get(url, { params: fullParams });
      return data;
    },
    enabled,
    ...(refetchInterval !== undefined && { refetchInterval }),
    keepPreviousData: true,
  } as UseQueryOptions<PaginatedResponse<T>, Error>);
};
